import React from 'react';
import ConversationArea from './conversationarea/ConversationArea';
import ChatInputBar from './chatinputbar/ChatInputBar';
import { useChatHandlers } from './hooks/useChatHandlers';
import { StyledChatContainer } from './Chat.styled';
import ErrorSnackBar from '../shared-components/errorsnackbar/ErrorSnackBar';
import StartNewChat from './newchatbutton/StartNewChat';

const ChatContainer: React.FC = () => {
  const { messages, isLoading, handleSendMessage, handleSendMessageWithFile, error, setError } = useChatHandlers();

  return (
    <StyledChatContainer>
      {error && <ErrorSnackBar errorMessage={error} severity='error' onClose={() => setError(null)} />}
      {messages?.length > 0 && <StartNewChat />}
      <ConversationArea messages={messages} isLoading={isLoading} />
      <ChatInputBar messages={messages} onSendMessage={handleSendMessage} onHandleSendMessageWithImage={handleSendMessageWithFile} isHomeView={messages.length === 0} onCloseError={() => setError(null)} /> 
    </StyledChatContainer>
  );
};

export default ChatContainer;